<template>
    <Article>
        <template #header>
            <h2>Burman News</h2>
        </template>
        <template #content>
            <div id="post-59" class="clearfix post-59 page type-page status-publish hentry">
                <p>
                    <em>The Burman News</em>
                    is the official newsletter of the Merrill's Marauders Association. This
                    newsletter was started in 1979 and was published for many years thanks to the
                    continued efforts of Robert Passanisi, Editor and President of the association.
                    <em>The Burman News</em>
                    has been a labor of love.
                </p>
                <p>
                    Thanks to Merrill's Marauders Proud Descendants Historian Hansel L. Haycox, we
                    are able to provide PDF versions of many past newsletters.
                </p>
                <p>
                    In 2013, the Proud Descendants took over production of
                    <em>The Burman News</em>
                    at the retirement of Robert Passanisi as Editor.
                    <em><br /></em>
                </p>
                <p>
                    When available, past issues will appear on this page. Click on the link to view
                    or download the newsletter issue.
                </p>
                <p style="text-align:center">
                    <strong>1979</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1979-1-Summer.pdf?alt=media"
                        target="_blank"
                    >
                        Summer
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1979-2-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1980</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1980-1-April.pdf?alt=media"
                        target="_blank"
                    >
                        April
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1980-2-Summer.pdf?alt=media"
                        target="_blank"
                    >
                        Summer
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1980-3-Winter.pdf?alt=media"
                        target="_blank"
                    >
                        Winter
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1981</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1981-1-Spring.pdf?alt=media"
                        target="_blank"
                    >
                        Spring
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1981-2-Summer.pdf?alt=media"
                        target="_blank"
                    >
                        Summer
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1981-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1982</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1981-1-Spring.pdf?alt=media"
                        target="_blank"
                    >
                        Spring
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1981-1-Spring.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1983</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1983-1-Fall.pdf?alt=media"
                        target="_blank"
                    >
                        Fall
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1984</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1984-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1984-2-June.pdf?alt=media"
                        target="_blank"
                    >
                        June
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1984-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1985</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1985-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1985-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1985-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1986</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1986-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1986-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1986-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1987</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1987-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1987-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1987-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1988</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1988-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1988-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1988-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1989</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1989-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1989-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1989-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1990</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1990-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1990-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1990-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1991</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1991-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1991-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1991-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1992</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1992-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1992-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1992-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1993</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1993-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1993-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1993-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1994</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1994-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1994-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1994-3-July.pdf?alt=media"
                        target="_blank"
                    >
                        July
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1995</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1995-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1995-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1995-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1995-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1996</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1996-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1996-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1996-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1997</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1997-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1997-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1997-3-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1998</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1998-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1998-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1998-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1998-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>1999</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1999-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1999-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1999-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/1999-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2000</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2000-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2000-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2000-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2000-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2001</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2001-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2001-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2001-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2001-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2002</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2002-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2002-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2002-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2002-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2003</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2003-1-February.pdf?alt=media"
                        target="_blank"
                    >
                        February
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2003-2-May.pdf?alt=media"
                        target="_blank"
                    >
                        May
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2003-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2003-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2006</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2006-1-March.pdf?alt=media"
                        target="_blank"
                    >
                        March
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2006-2-June.pdf?alt=media"
                        target="_blank"
                    >
                        June
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2006-3-August.pdf?alt=media"
                        target="_blank"
                    >
                        August
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/2006-4-November.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2012</strong>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-November-2012.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2013</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-March-2013.pdf?alt=media"
                        target="_blank"
                    >
                        March
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-July-2013.pdf?alt=media"
                        target="_blank"
                    >
                        July
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-November-2013.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2014</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-March-2014.pdf?alt=media"
                        target="_blank"
                    >
                        March
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-July-2014.pdf?alt=media"
                        target="_blank"
                    >
                        July
                    </a>
                    |
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-November-2014.pdf?alt=media"
                        target="_blank"
                    >
                        November
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>2015</strong>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/BN-Apr-2015.pdf?alt=media"
                        target="_blank"
                    >
                        April
                    </a>
                </p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'BurmanNews',
    components: { Article }
});
</script>
